<template>
  <m-dialog
    ref="dlg"
    @save="save"
    :title="instansi && instansi.id ? 'Ubah Instansi':'Tambah Instansi'"
  >
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <v-form @submit.prevent data-vv-scope="form" lazy-validation>
          <v-card flat class="pb-5 mb-5">
            <v-row class="px-5 pt-5">
              <v-col cols="12">
                <m-alert
                  show
                  :title="alert.instansi.form.judul"
                  :info="alert.instansi.form.deskripsi"
                  closable
                ></m-alert>
              </v-col>
            </v-row>
            <v-card-text class="pa-5">
              <v-row wrap>
                <v-col cols="12">
                  <v-text-field
                    outlined
                    dense
                    autocomplete="false"
                    name="Kode"
                    placeholder="Isikan Kode Instansi"
                    label="Kode"
                    v-model="instansi.kode"
                    persistent-hint
                    data-vv-name="kode"
                    data-vv-as="Kode"
                    v-validate="'required'"
                    :error-messages="errors.collect('form.kode')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    outlined
                    dense
                    autocomplete="false"
                    name="Nama"
                    placeholder="Isikan Nama Instansi"
                    label="Nama"
                    v-model="instansi.nama"
                    persistent-hint
                    data-vv-name="nama"
                    data-vv-as="Nama"
                    v-validate="'required'"
                    :error-messages="errors.collect('form.nama')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    outlined
                    dense
                    :disabled="instansi.is_sync"
                    autocomplete="false"
                    v-model="instansi.moodle"
                    :items="itemMoodles"
                    no-data-text="Data Tidak Tersedia"
                    placeholder="Pilih Moodle"
                    label="Untuk Moodle"
                    name="Moodle"
                    item-value="id"
                    item-text="nama"
                    data-vv-name="moodle"
                    data-vv-as="Moodle"
                    return-object
                    v-validate="'required'"
                    :error-messages="errors.collect('form.moodle')"
                  ></v-autocomplete>
                </v-col>
                <!-- <v-col cols="12">
                  <v-textarea
                    outlined
                    autocomplete="false"
                    name="Deskripsi"
                    placeholder="Isikan Deskripsi"
                    label="Deskripsi"
                    v-model="instansi.deskripsi"
                    persistent-hint
                    data-vv-name="deskripsi"
                    data-vv-as="Deskripsi"
                    v-validate="''"
                    :error-messages="errors.collect('form.deskripsi')"
                  ></v-textarea>
                </v-col>-->
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import { ALERT_INFO } from "@/const";
export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {},

  data() {
    return {
      instansi: {},
      defModul: {
        nama: ""
      },
      itemMoodles: [],
      alert: ALERT_INFO,
      current_page: 1,
      page: null,
      cp: 1
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.loadMoodle();
      this.instansi = obj ? { ...obj } : { ...this.defModul };
      let x = this.$refs.dlg.open();
      this.$validator.reset();
      return x;
    },

    loadMoodle() {
      return this.$store
        .dispatch("instansi/getMoodle", {})
        .then(res => {
          this.itemMoodles = res;
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.instansi.moodle_id = 1;
          return this.$store
            .dispatch("instansi/form", this.instansi)
            .then(res => {
              this.$refs.dlg.resolve();
              return res;
            })
            .catch(e => e);
        })
        .catch(e => e);
    }

    // saveAndLoad() {
    //   this.$validator
    //     .validateAll("form")
    //     .then(res => {
    //       if (!res) return Promise.reject();
    //       return res;
    //     })
    //     .then(() => {
    //       this.instansi.moodle_id = 1;
    //       return this.$store
    //         .dispatch("instansi/form", this.instansi)
    //         .then(res => {
    //           this.$info(
    //             "Simpan Data Berhasil. Silakan menambahkan Instansi Baru"
    //           );
    //           this.instansi = { ...this.defModul };
    //           this.$validator.reset();
    //           // this.$refs.dlg.resolve();
    //           return res;
    //         })
    //         .catch(e => e);
    //     })
    //     .catch(e => e);
    // }
  }
};
</script>


